import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en'
import vi from './locales/vi'

const resources = {
  en: {
    translation: en,
  },
  vi: {
    translation: vi,
  },
}

i18n.use(initReactI18next).init({
  fallbackLng: false,
  debug: true,
  interpolation: {
    escapeValue: false,
  },
  resources,
})

export default i18n
